import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { LAYOUT_BUNDLING, LAYOUT_DEFAULT } from '../../layout';
import { SORT_VALUE } from '../ShipmentBundling/constants';

const BundlingMode = ({ enabled, setLayout }) => {
  if (!enabled) {
    const startBundling = () => {
      setLayout(LAYOUT_BUNDLING, {
        shipping: true,
        shipped: null,
        trackingNumber: '',
        orderBy: SORT_VALUE,
        order: 'asc',
        page: 1
      });
    };

    return (
      <Button
        color="primary"
        title="Start Bundling"
        onClick={startBundling}
        variant="contained"
        style={{ marginLeft: 8 }}
      >
        Start Bundling
      </Button>
    );
  }

  const exitBundling = () => {
    setLayout(LAYOUT_DEFAULT, {
      shipping: null,
      shipped: null,
      trackingNumber: '',
      orderBy: 'ship_date_sort',
      order: 'asc',
      page: 1
    });
  };

  return (
    <Button color="secondary" title="Exit Bundling" onClick={exitBundling} variant="contained">
      Exit Bundling
    </Button>
  );
};

BundlingMode.propTypes = {
  enabled: PropTypes.bool.isRequired,
  setLayout: PropTypes.func.isRequired
};

export default BundlingMode;
